import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  return _openBlock(), _createElementBlock("div", {
    class: "c-video",
    style: _normalizeStyle($options.styles),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click'))
  }, [_createVNode(_component_svg_icon, {
    class: "c-video-play",
    "icon-class": "play"
  })], 4);
}